import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCFpmpthbVE7HX4fK6ZywNlm3VYmHiy_Yg",
  authDomain: "esc-voting-10822.firebaseapp.com",
  projectId: "esc-voting-10822",
  storageBucket: "esc-voting-10822.firebasestorage.app",
  messagingSenderId: "40352745736",
  appId: "1:40352745736:web:6f3b0541d7bf69f71a84bd",
  measurementId: "G-E9CYEH640Y",
};

// init app
const app = initializeApp(firebaseConfig);

// init firestore database
const database = getFirestore(app);

// init autenticazione firebase
const autenticazione = getAuth(app);

// init storage
const filesCloud = getStorage(app);

// init cloudFunctions
const functions = getFunctions(app);

// timestamp
const timestamp = Timestamp;

export { database, autenticazione, timestamp, filesCloud, functions };
